// imports
import Overlay from 'minsky-kit/js/components/Overlay';
import Packery from 'packery';

// private statics
const VERSION = '1.0.0';

// class definition
export default class CircleMenuOverlay extends Overlay {
    // constructor
    constructor (args = {}, objectName = 'Circle-Overlay') {
        args.debug = args.debug || false;

        // super
        super(args, objectName);

        //test for circles packery
        const container = this.$el.querySelector('.menu-overview .menu__list');
        this.circlePackery = new Packery ( container, {
            // Options
            itemSelector: '.menu__item',
            gutter: 10,
            stamp: '.stamp',
            containerStyle: null
        });
    }

    destroy () {
        // super destroy
        super.destroy();
    }

    show () {
        // this.triggers[0].classList.add('active');
        super.show();
        this.circlePackery.layout();
    }

    hide () {
        // this.triggers[0].classList.remove('active');
        super.hide();
    }

    // getters & setters
    static get version () { return VERSION; }
}
